@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Kentucky</h2>
}

@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Kentucky</h2>
  @if (baseRules?.noSelection === "Yes") {
    <div class="axis-form-group">
      <label class="axis-control-label">{{ textValues?.Minimum_Limits_Text }}</label>
    </div>
  }
}
